import axios from "axios";
import React from "react";
import constants from "../utilities/constants.json";
import { useDispatch, useSelector } from "react-redux";
import { SiteUnderMaintenance, UpdateSiteStatus } from "../actions";

const apiUrl = constants.server + "site_status";

function useMaintenanceStatus() {
  const siteStatus = useSelector((state) => state.siteStatus);
  const dispatch = useDispatch();

  React.useEffect(() => {
    const fetchMaintenanceStatus = async () => {
      try {
        const response = await axios.get(apiUrl);
        const siteStatus =
          response.data.status === 1 ? !!response.data.data.site_status : true;
        if (!siteStatus) dispatch(UpdateSiteStatus("under_maintenance"));
      } catch (error) {
        console.error("Error fetching maintenance status:", error);
        dispatch(UpdateSiteStatus());
      }
    };

    fetchMaintenanceStatus();
  }, []);

  return { underMaintenance: siteStatus === "under_maintenance" };
}

function useSetUnderMaintenance() {
  const dispatch = useDispatch();

  const setSiteUnderMaintenance = () => {
    dispatch(SiteUnderMaintenance());
  };

  return { setSiteUnderMaintenance };
}

export { useMaintenanceStatus, useSetUnderMaintenance };
